export const SAGA_LOAD_ORGANIZATIONS = 'SAGA_LOAD_ORGANIZATIONS';

export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS';

export const sagaLoadOrganizations = (country) => ({
    type: SAGA_LOAD_ORGANIZATIONS,
    payload: {
        country,
    }
});


// WEBPACK FOOTER //
// ./src/shared/actions.js